import { useAppDispatchV1 } from "@redux/hooks";
import { useCallback } from "react";
import { createAction, nanoid } from "@reduxjs/toolkit";
import { Level, Link, Message, Action } from "@app/_components/Notifications";

export type NotificationArgs = {
  id?: string;
  message: Message;
  level?: Level;
  link?: Link;
  action?: Action;
};

export type Notification = NotificationArgs & { id: string };

export const showNotification = createAction(
  "notifications/show",
  (notification: NotificationArgs) => {
    return {
      payload: {
        ...notification,
        id: notification.id ?? nanoid(),
      },
    };
  }
);

export const dismissNotification = createAction("notifications/dismiss", (id: string) => {
  return { payload: { id } };
});

export default function useNotifications() {
  const dispatch = useAppDispatchV1(),
    _showNotifcation = useCallback(
      (args: NotificationArgs) => {
        dispatch(showNotification(args));
      },
      [dispatch]
    ),
    _dismissNotification = useCallback(
      (...args: Parameters<typeof dismissNotification>) => {
        dispatch(dismissNotification(...args));
      },
      [dispatch]
    );

  return { showNotification: _showNotifcation, dismissNotification: _dismissNotification };
}
